/**
 * 앱 엔트리 포인트
 *
 * React 앱의 시작점입니다.
 * 여기서 Provider들을 설정하고 App 컴포넌트를 마운트합니다.
 *
 * Provider 구조:
 * - React.StrictMode: 개발 모드에서 잠재적 문제 감지
 * - BrowserRouter: React Router (클라이언트 사이드 라우팅)
 * - I18nProvider: 다국어 지원 (영어/한국어)
 */

import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { I18nProvider } from './i18n'
import App from './App'
import './index.css'

// =============================================================================
// 앱 렌더링
// =============================================================================

/**
 * React 앱을 DOM에 마운트
 *
 * document.getElementById('root')!
 * - index.html의 <div id="root"></div>를 찾음
 * - ! 는 null이 아님을 보장 (TypeScript non-null assertion)
 */
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {/* 클라이언트 사이드 라우팅 */}
    <BrowserRouter>
      {/* 다국어 지원 - 앱 전체에서 useI18n() 사용 가능 */}
      <I18nProvider>
        <App />
      </I18nProvider>
    </BrowserRouter>
  </React.StrictMode>,
)
